import * as React from "react"

import Layout from "../components/Layout"

const AMOPricing = () => {
  return (
    <Layout>
      <h2>Pricing For Your AMO Unit ...</h2>

      <iframe
        title="AMO_Pricing"
        width="100%"
        height="600px"
        src="/Pricing.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default AMOPricing
